import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { KillOnDestroy } from '@sg/utils';
import { combineLatest } from 'rxjs';
import { skip, tap } from 'rxjs/operators';
import { SG_BREAKPOINTS, SG_BREAKPOINTS_VALUES } from '../responsive';
import { EnvironmentService, SgTranslationService } from '../services';
import { SgTopNavService } from './top-nav.service';

@Component({
  selector: 'sg-top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
@KillOnDestroy()
export class SgTopNavComponent {
  @Input() logoSrc: string;
  @Input() showLogoAt: SG_BREAKPOINTS;
  @Input() hideActionsMenu: boolean;
  @Input() showBurgerMenu: boolean;
  @Input() @HostBinding('class.sticky') isSticky: boolean;
  @Input() isOnColor = false;

  @Output() menuButtonClick = new EventEmitter();
  @Output() logoutClick = new EventEmitter();
  @Output() langClick = new EventEmitter<string>();

  _showLogo = true;
  homeUrl: string;

  constructor(
    public sgTranslation: SgTranslationService,
    public sgEnv: EnvironmentService,
    public topNavService: SgTopNavService,
    private cdr: ChangeDetectorRef,
    private breakpointObserver: BreakpointObserver
  ) {
    const url = new URL(location.toString());
    url.hash = '';
    url.search = '';
    url.pathname = sgEnv.appName;
    this.homeUrl = url.toString();
  }

  ngAfterViewInit(): void {
    if (this.showLogoAt) {
      const mediaQuery = SG_BREAKPOINTS_VALUES[this.showLogoAt];
      this.breakpointObserver
        .observe([mediaQuery])
        .pipe(
          tap((state) => {
            if (this._showLogo !== state.matches) {
              this._showLogo = state.matches;
              this.cdr.detectChanges();
            }
          }),
          KillOnDestroy(this)
        )
        .subscribe(() => {});
    }

    combineLatest([this.topNavService.headerItems$, this.topNavService.menuItems$, this.topNavService.navbarItems$])
      .pipe(skip(1), KillOnDestroy(this))
      .subscribe(() => this.cdr.detectChanges());

    this.topNavService.setIsOnColor(this.isOnColor);
  }
}
